var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-card',[_c('v-card-text',[_c('PayPal',{attrs:{"amount":"10.00","currency":"USD","client":_vm.credentials,"env":"sandbox"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }